<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Book Description</span></p>
<p class="P_WFP_BodyTextFirstPara">In <i>The Jesus Incident</i> Herbert and Ransom introduced Ship, an artificial intelligence that believed it was God, abandoning its unworthy human cargo on the all-sea world of Pandora. Now centuries have passed. The descendants of humanity, split into Mermen and Islanders, must reunite … because Pandora’s original owner is returning to life!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?4c89c0a4